import { AuthResponse } from "../../models/responses/auth.response";
import { EnvService } from "../../environments/environment.factory";
import { ForgotResponse } from "../../models/responses/forgot.response";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { ResetResponse } from "../../models/responses/reset.response";
import { prepareAuthHeaders } from "../headers";

/*
  Generated class for the AuthProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AuthProvider {
  private environment: any;

  constructor(private http: HttpClient, private env: EnvService) {
    this.environment = env;
  }

  public login(credentials: { email: string; password: string }) {
    return this.http.post<AuthResponse>(
      `${this.environment.api}/v1/login`,
      credentials
    );
  }

  public logout() {
    const headers = prepareAuthHeaders();
    return this.http.post(`${this.environment.api}/v1/logout`, {}, { headers });
  }

  public forgot(credentials: { email: string }) {
    return this.http.post<ForgotResponse>(
      `${this.environment.api}/v1/password/email`,
      credentials
    );
  }

  public reset(credentials: {
    email: string;
    password: string;
    token: string;
  }): Observable<any> {
    return this.http.post<ResetResponse>(
      `${this.environment.api}/v1/password/reset`,
      credentials
    );
  }

  public activate(credentials: {
    token: string;
    email: string;
    password: string;
    password_confirmation: string;
  }) {
    return this.http.post<ResetResponse>(
      `${this.environment.api}/v1/activate`,
      credentials
    );
  }

  public me() {
    const headers = prepareAuthHeaders();
    return this.http.get<AuthResponse>(`${this.environment.api}/v1/me`, {
      headers,
    });
  }

  public ping() {
    const headers = prepareAuthHeaders();
    return this.http.get(`${this.environment.api}/v1/ping`, { headers });
  }
}



// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts